import { useState } from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import Iconify from '../iconify';

export default function ScopeSelector({ label, value, options, onChange }) {
  const [anchor, setAnchor] = useState(null);
  return (
    <>
      <Typography
        variant="caption"
        onClick={e => setAnchor(e.currentTarget)}
        sx={{
          cursor: 'pointer', fontWeight: 600, fontSize: '0.8rem',
          color: value ? 'text.primary' : 'text.disabled',
          px: 1, py: 0.25, borderRadius: 1,
          '&:hover': { bgcolor: 'action.hover' },
          whiteSpace: 'nowrap', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis',
        }}
      >
        {value || label}
        <Iconify icon="eva:chevron-down-fill" sx={{ ml: 0.25, width: 14, height: 14, verticalAlign: 'middle' }} />
      </Typography>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
        slotProps={{ paper: { sx: { maxHeight: 300, minWidth: 160 } } }}>
        {options.map(o => (
          <MenuItem key={o.id ?? 'all'}
            onClick={() => { onChange(o); setAnchor(null); }}
            sx={{ fontSize: 13 }}>
            {o.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
